import script from "./AddressBlockEthereum.vue?vue&type=script&setup=true&lang=js"
export * from "./AddressBlockEthereum.vue?vue&type=script&setup=true&lang=js"

import "./AddressBlockEthereum.vue?vue&type=style&index=0&id=4f18bb6f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f18bb6f"]])

export default __exports__